import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";

import { camelToSnake, snakeToCamel } from "caseparser";

export const productsApi = api
  .enhanceEndpoints({ addTagTypes: ["products", "categories", "branchs"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      createProduct: builder.mutation({
        query: ({
          name,
          description,
          amount,
          price,
          currency,
          reference,
          userId,
          branchId,
          categoryId,
          category,
          codePromotional,
          img,
          link,
          cost,
          supplier,
        }) => ({
          url: `branchs/${branchId}/products`,
          method: RequestMethod.POST,
          body: {
            name,
            amount,
            branch_id: branchId,
            price,
            description,
            currency,
            category_id: String(categoryId),
            category,
            reference,
            user_id: userId,
            code_promotional: codePromotional,
            img,
            link,
            cost,
            supplier,
          },
        }),
        invalidatesTags: ["products", "categories"],
      }),
      updateProduct: builder.mutation({
        query: ({
          productId,
          name,
          description,
          amount,
          price,
          currency,
          reference,
          userId,
          branchId,
          categoryId,
          category,
          codePromotional,
          img,
          link,
          cost,
          supplier,
        }) => {
          return {
            url: `branchs/${branchId}/products/${productId}`,
            method: RequestMethod.PUT,
            body: {
              name,
              amount,
              product: productId,
              branch_id: branchId,
              price,
              description,
              currency,
              category_id: String(categoryId),
              category,
              reference,
              user_id: userId,
              code_promotional: codePromotional,
              img,
              link,
              cost,
              supplier,
            },
          };
        },
        invalidatesTags: ["products", "categories"],
      }),
      deleteProduct: builder.mutation({
        query: ({ branchId, id }) => ({
          url: `branchs/${branchId}/products/${id}`,
          method: RequestMethod.DELETE,
        }),
        invalidatesTags: ["products"],
      }),
      productsStore: builder.query({
        query: ({ branchId, search, categoryIds, minAmount, page }) => ({
          url: `branchs/${branchId}/products`,
          method: RequestMethod.GET,
          params: camelToSnake({
            search,
            categoryIds,
            minAmount,
            page: page,
            active: 1,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["products"],
      }),
      categories: builder.query({
        query: ({ branchId }) => ({
          url: `branchs/${branchId}/products/categories`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["categories"],
      }),
      downloadStock: builder.mutation({
        query: ({ branchId }) => ({
          url: `/store/product/download/${branchId}`,
          method: RequestMethod.GET,
          responseHandler: async (response) => {
            console.log("response", response);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "products.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          },
        }),
      }),
      downloadStockHistory: builder.mutation({
        query: ({ branchId }) => ({
          url: `/store/product/history/${branchId}`,
          method: RequestMethod.GET,
          responseHandler: async (response) => {
            console.log("response", response);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "historial_tienda.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          },
        }),
      }),
      activeAppStock: builder.mutation({
        query: ({ branchId }) => ({
          url: `/branchs/${branchId}/store/update_status`,
          method: RequestMethod.PUT,
        }),
        invalidatesTags: ["branchs"],
      }),
      addStock: builder.mutation({
        query: ({ branchId, productId, amount }) => ({
          url: `/store/product/add-stock`,
          method: RequestMethod.POST,
          body: { amount, product_id: productId, branch_id: branchId },
        }),
        invalidatesTags: ["products"],
      }),
      subtractStock: builder.mutation({
        query: ({ branchId, productId, amount }) => ({
          url: `/store/product/subtract-stock`,
          method: RequestMethod.POST,
          body: { amount, product_id: productId, branch_id: branchId },
        }),
        invalidatesTags: ["products"],
      }),
      deleteProductPermanently: builder.mutation({
        query: ({ branchId, productId }) => ({
          url: `/branchs/${branchId}/products/${productId}`,
          method: RequestMethod.DELETE,
        }),
      }),
    }),
  });

export const {
  useProductsStoreQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
  useDownloadStockMutation,
  useDownloadStockHistoryMutation,
  useActiveAppStockMutation,
  useCategoriesQuery,
  useAddStockMutation,
  useSubtractStockMutation,
  useDeleteProductPermanentlyMutation,
} = productsApi;
